import { defaultNavItems } from "../../_layouts/navigation/config/dashboardNavigation";
import { defaultSettingsItems } from "../../_layouts/navigation/config/settingsNavigation";

/**
 * Flattens the two sidenav config trees (main dashboard rail + settings
 * rail) into a single list of jump-to-page commands for the command
 * center. A group header with `ddItems` (e.g. "Configure billing") isn't
 * itself a real page in either config, so only leaves (items with a real
 * `path` and no children) become commands - this also naturally dedupes
 * "Users & Roles" → "User management" both pointing at the same path.
 */
const flattenLeaves = (items, group) => {
  const out = [];
  items.forEach((item) => {
    if (Array.isArray(item.ddItems) && item.ddItems.length > 0) {
      item.ddItems.forEach((child) => {
        if (child.path) out.push({ label: child.menuItem, path: child.path, group, run: (ctx) => ctx.navigate(child.path) });
      });
    } else if (item.path) {
      out.push({ label: item.menuItem, path: item.path, group, run: (ctx) => ctx.navigate(item.path) });
    }
  });
  return out;
};

export const getNavigationCommands = () => {
  const pages = flattenLeaves(defaultNavItems, "Pages");
  const settings = flattenLeaves(defaultSettingsItems, "Settings");

  const seen = new Set();
  return [...pages, ...settings]
    .filter((entry) => {
      if (seen.has(entry.path)) return false;
      seen.add(entry.path);
      return true;
    })
    .map((entry) => ({ id: `page-${entry.path}`, ...entry }));
};
